import { Card, CardTitle, DataList } from '@serodigital/ui-components';
import { DateTime } from 'luxon';
import * as React from 'react';
import { IDeviceInfo } from '../state/types';

const DEFAULT_NULL_VALUE = 'Unknown';

function generateBeeColour(status: string) {
  return status === 'Offline' ? (
    <span className="text-common-error">Offline</span>
  ) : (
    <span className="text-common-success-2">Online</span>
  );
}

type DataDefinition = {
  label: string;
  key: string;
  dataTransform?: (data: Omit<IDeviceInfo, 'udprn'>, key: string) => JSX.Element | string;
};

export const dataListItems: DataDefinition[] = [
  {
    label: 'BEE ID',
    key: 'deviceId',
  },
  { label: 'Router MAC Address', key: 'routerId' },
  {
    label: 'Status',
    key: 'status',
    dataTransform: (data: Omit<IDeviceInfo, 'udprn'>) => generateBeeColour(data.status),
  },
  {
    label: 'Last Status',
    key: 'stateLastUpdated',
    dataTransform: (data: Omit<IDeviceInfo, 'udprn'>, key: string) => {
      if (data[key] === null) return '-';
      return DateTime.fromISO(data[key], { zone: 'utc' })
        .toLocal()
        .toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
    },
  },
  { label: 'Hardware', key: 'hardwareVersion' },
  {
    label: 'BEE Mode',
    key: 'beeMode',
    dataTransform: (data: Omit<IDeviceInfo, 'udprn'>, key: string) =>
      data.config?.metadata?.[key] || DEFAULT_NULL_VALUE,
  },
  {
    label: 'Config Version',
    key: 'configProfileVersion',
    dataTransform: (data: Omit<IDeviceInfo, 'udprn'>, key: string) =>
      data.config?.metadata?.[key] || DEFAULT_NULL_VALUE,
  },
  { label: 'Firmware Version', key: 'currentFirmwareVersion' },
  {
    label: 'Firmware Update Requested',
    key: 'firmwareUpdateRequested',
    dataTransform: (data: Omit<IDeviceInfo, 'udprn'>, key: string) => {
      if (data[key] === null) return '-';
      return DateTime.fromISO(data[key], { zone: 'utc' })
        .toLocal()
        .toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
    },
  },
  { label: 'Firmware Update Version', key: 'firmwareUpdateVersion' },
  {
    label: 'Uptime',
    key: 'uptime',
    dataTransform: (data: Omit<IDeviceInfo, 'udprn'>, key: string) => {
      if (data.status === 'Offline') return '-';

      return data[key];
    },
  },
];

export function Overview(data: Omit<IDeviceInfo, 'udprn'>) {
  return (
    <div className="w-1/2">
      <Card data-qa={'overview-card'} CardTitle={<CardTitle title={'BEE Overview'} />}>
        <DataList
          items={dataListItems.map(({ label, key, dataTransform }) => ({
            label,
            key: `${key}`,
            data: dataTransform ? dataTransform(data, key) : data[key] ?? '-',
          }))}
        />
      </Card>
    </div>
  );
}
